import { Form, Input, Row, Col, Switch, Select, DatePicker, InputNumber } from 'antd';
import { useRef, useEffect, useState } from 'react';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import fetchApi from '../../../utils/api/fetchApi';
import getList from '../../../utilsTsx/universal/getList';
import objectHandle from '../../../utilsTs/baseLib/objectHandle';
import GiftCardSelect from './customize/GiftCardSelect';

//布局
const layout = {
    // labelCol: { span: 8 },
    // wrapperCol: { span: 16 },
};

const EditComponent = (props: any) => {
    const [form] = Form.useForm();
    const { data } = props;
    const ref = useRef<any>(undefined);
    const [membershipData, setMembershipData] = useState<any>();
    const [membershipTransactionData, setMembershipTransactionData] = useState<any>();
    const [defaultService, setDefaultService] = useState<string>('');
    const [membershipPointsDetailsData, setMembershipPointsDetailsData] = useState<boolean>(false);
    const [giftCardPlansData, setGiftCardPlansData] = useState<any>();
    const [membershipMarketingPlansData, setMembershipMarketingPlansData] = useState<any>();
    const [merchantData, setMerchantData] = useState<any>();
    const [shopData, setShopData] = useState<any>();

    useEffect(() => {
        let urlService: any = '';
        if (ref.current) {
            urlService = ref.current.defaultService;
            setDefaultService(urlService);
            ref.current.row.then((res: any) => {
                if (res?.success === true) {
                    // const rewardGiftCardIds = res.data.rewardGiftCardIds;
                    // let rewardGiftCardIdsRows;
                    // if (objectHandle.isEmpty(rewardGiftCardIds) === false) {
                    //     rewardGiftCardIdsRows = rewardGiftCardIds.split('@');

                    // }
                }
            })
        }
        fetchApi.GET(urlService,
            {
                apiId: 'generalData',
                apiVariable: 'membershipTransaction',
                apiExtend: 'showLists'
            }).then(res => {
                if (res.success) {
                    const { membershipTransaction } = res.data;
                    setMembershipTransactionData(membershipTransaction);;
                }
            });
        fetchApi.GET(urlService,
            {
                apiId: 'membership',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setMembershipData(res.data);
                }
            });
        fetchApi.GET(urlService,
            {
                apiId: 'membershipMarketingPlans',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setMembershipMarketingPlansData(res.data);
                }
            });
        fetchApi.GET(urlService,
            {
                apiId: 'membershipPointsDetails',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setMembershipPointsDetailsData(res.data);
                }
            });
        fetchApi.GET(urlService,
            {
                apiId: 'merchant',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setMerchantData(res.data);
                }
            })
        fetchApi.GET(urlService,
            {
                apiId: 'shop',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setShopData(res.data);
                }
            })
    }, []);

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'membershipMarketingDetails',
        serviceId: 'business',
        dateColumnName: ['successfulDate', 'pointsVoidDate', 'giftCardVoidDate']
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '营销详细'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={1080}
            >
                <Form
                    {...layout}
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            // handleOk(e)
                        }
                    }}>

                    <Row gutter={[8, 0]}>
                        <Col span={4}>
                            <Form.Item
                                label="ID"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="会员"
                                name="membershipId"
                                tooltip='会员'>
                                <Select
                                    showSearch
                                    placeholder="会员"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(membershipData, {
                                        setItemNameFun(item: any) {
                                            return {
                                                id: item.id,
                                                name: `${item.membershipInfo?.membershipName}-${item.membershipType?.typeName}`
                                            }
                                        }
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="方案"
                                name="membershipMarketingPlansId"
                                tooltip='营销方案'
                                rules={[{ required: true, message: '请选择营销方案!' }]}>
                                <Select
                                    showSearch
                                    placeholder="营销方案"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(membershipMarketingPlansData, {
                                        itemName: 'planName'
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="类型"
                                name="membershipGiftTypeId"
                                tooltip='会员赠送交易类型'
                                rules={[{ required: true, message: '会员赠送交易类型!' }]}>
                                <Select
                                    showSearch
                                    placeholder="交易类型"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(membershipTransactionData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={3}>
                            <Form.Item
                                label="成功"
                                name="isGiftSuccessful"
                                tooltip='赠送成功'
                                valuePropName="checked"
                                initialValue={false}>
                                < Switch
                                    checked={false}
                                    checkedChildren="是"
                                    unCheckedChildren="否" />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="成功日期"
                                name="successfulDate">
                                <DatePicker
                                    format="YYYY-MM-DD HH:mm:ss" />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="积分"
                                name="membershipPointsDetailsIds"
                                tooltip='积分交易ids' >
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={3}>
                            <Form.Item
                                label="撤销"
                                name="isPointsVoid"
                                tooltip='积分撤销成功'
                                valuePropName="checked"
                                initialValue={false}>
                                < Switch
                                    checked={false}
                                    checkedChildren="是"
                                    unCheckedChildren="否" />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="撤销日期"
                                name="pointsVoidDate"
                                tooltip='积分撤销日期'>
                                <DatePicker
                                    format="YYYY-MM-DD HH:mm:ss" />
                            </Form.Item>
                        </Col>

                        <Col span={7}>
                            <Form.Item
                                label="礼品卡"
                                name="giftCardAssociationIds"
                                tooltip='礼品卡交易ids'>
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={3}>
                            <Form.Item
                                label="撤销"
                                name="isGiftCardVoid"
                                tooltip='礼品卡撤销成功'
                                valuePropName="checked"
                                initialValue={false}>
                                < Switch
                                    checked={false}
                                    checkedChildren="是"
                                    unCheckedChildren="否" />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="撤销日期"
                                name="giftCardVoidDate"
                                tooltip='礼品卡撤销日期'>
                                <DatePicker
                                    format="YYYY-MM-DD HH:mm:ss" />
                            </Form.Item>
                        </Col>

                        <Col span={5}>
                            <Form.Item
                                label="操作人"
                                name="userId" >
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={3}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="商户"
                                name="merchantId">
                                <Select
                                    showSearch
                                    placeholder="商户"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(merchantData, { itemName: 'merchantName', includeNull: true })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="店铺"
                                name="shopId">
                                <Select
                                    showSearch
                                    placeholder="店铺"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(shopData, { itemName: 'shopName', includeNull: true })}
                                </Select>
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default EditComponent;